<template>
  <div>
    <div v-if="!ddnStore.loading && !ddnStore.error && ddnStore.data">
      <v-list>
        <v-list-item>
          <template #prepend>
            <v-icon :color="ddnStore.data.color">{{ ddnStore.data.icon }}</v-icon>
          </template>

            <v-list-item-subtitle>Status</v-list-item-subtitle>
            <v-list-item-title>{{ ddnStore.data.status }}</v-list-item-title>

        </v-list-item>
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-calendar</v-icon>
          </template>

            <v-list-item-subtitle>Datum</v-list-item-subtitle>
            <v-list-item-title>{{ `${ddnStore.data.DatumFormatted} ${ddnStore.data.UhrZeit} Uhr` }}</v-list-item-title>

        </v-list-item>
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-account</v-icon>
          </template>

            <v-list-item-subtitle>Kunde</v-list-item-subtitle>
            <v-list-item-title>{{ ddnStore.data.Kundname }}</v-list-item-title>

        </v-list-item>
        <v-list-item v-if="ddnStore.data.Lieferung.GeplantLieferdatum">
          <template #prepend>
            <v-icon>mdi-timer</v-icon>
          </template>

            <v-list-item-subtitle>Geplantes Lieferdatum</v-list-item-subtitle>
            <v-list-item-title>{{ ddnStore.data.GeplantLieferdatumFormatted }}</v-list-item-title>

        </v-list-item>
      </v-list>
      <div v-if="ddnStore.data.Archiv?.Values" class="pb-3 px-3">
        <ApiDownload
          title="Lieferschein herunterladen"
          :token="ddnStore.data.Archiv.Values[0].DownloadToken"
          :fileName="ddnStore.data.Archiv.Values[0].Dateiname"
        />
      </div>
      <hr />
      <v-table>
        <tbody>
          <tr v-for="position in ddnStore.data.Positionen" :key="position.PosNr">
            <td class="py-2" valign="top" width="55">
              {{ position.PosNr }}
            </td>
            <td class="py-2" valign="top" width="55">
              {{ position.Menge }} <small>{{ position.Einheit }}</small>
            </td>
            <td class="py-2">
              <strong>{{ position.ArtikelBezeichnung1 }}</strong
              ><br />
              <div v-if="position.ArtikelBezeichnung2">
                {{ position.ArtikelBezeichnung2 }}<br />
              </div>
              <em>Art.-Nr.: {{ position.ArtikelNr }}</em>
            </td>
          </tr>
        </tbody>
      </v-table>
      <div v-if="(ddnStore.data.Dateien?.Values?.length ?? 0) > 0|| (ddnStore.data.Unterlagen?.Values.length ?? 0) > 0">
        <hr>
        <Downloads :dateien="ddnStore.data.Dateien?.Values" :unterlagen="ddnStore.data.Unterlagen?.Values" />
      </div>
    </div>
    <template v-else-if="ddnStore.error">
      <error :module="ddnStore.$id" />
    </template>
  </div>
</template>
<script setup lang="ts">
import ErrorComp from '@/components/Error.vue';
import Downloads from '@/components/Downloads.vue';
import ApiDownload from '@/components/ApiDownload.vue';
import {useStorage} from '@/composables/storage';
import useDetailDeliveryNoteStore from '@/store/detailDeliveryNote';

const ddnStore = useDetailDeliveryNoteStore();
const {} = useStorage(ddnStore,
    (data) => data?.VerkauflieferscheinNr ? `Lieferschein ${data.VerkauflieferscheinNr}` : 'Lieferschein',
    (route) => {
      return {
        VerkauflieferscheinNr: parseInt(Array.isArray(route.params.delivery_note_id) ?
          route.params.delivery_note_id[0] :
          route.params.delivery_note_id),
      };
    });

defineExpose({
  Error: ErrorComp,
  Downloads: Downloads,
  ApiDownload,
  ddnStore,
});
</script>
